/**
 * Product Service
 */

DM.Service.Product = (function ($) {
    var URL = {
        PRODUCT: '/products/data?id=',
        SECTIONS: '/products/getsections?id='
    };

    return {
        _fetchFromServer: function (url, id, params) {
            var queryParams = params ? '&' + params : '';
            return fetch(url + id + queryParams).then(response => response.json());
        },
        getProduct: function (id, urlSuffix) {
            return new Promise((resolve, reject) => {
                this._fetchFromServer(URL.PRODUCT, id, urlSuffix)
                    .then(function (response) {
                        resolve(response);
                    }.bind(this))
                    .catch(function (error) {
                        reject(error);
                    });
            });
        },
        getSections: function (id) {
            return new Promise((resolve, reject) => {
                this._fetchFromServer(URL.SECTIONS, id)
                    .then(function (response) {
                        resolve(response);
                    }.bind(this))
                    .catch(function (error) {
                        reject(error);
                    });

            });
        }
    };
})(window.jQuery);
